import appConfig from "appConfig";

async function getWorldRanking(date, gender, accessToken) {
  const url = `${appConfig.apiBaseUrl}/GetWorldRankingTableByDatetime?date_Y_m_d=${encodeURIComponent(
    date
  )}&gender=${encodeURIComponent(gender)}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
}

export default getWorldRanking;
